import type { Instrument } from '@thinkalpha/common/schemas/instruments.js';

export type UpdateMessagesInstrumentAction = {
    type: 'updateMessagesInstrument' | 'linkingUpdateMessagesInstrument';
    tabId: string;
    instrument: Instrument;
};
export const updateMessagesInstrument = (
    tabId: string,
    instrument: Instrument,
    isLinking = false,
): UpdateMessagesInstrumentAction => ({
    tabId,
    instrument,
    type: isLinking ? 'linkingUpdateMessagesInstrument' : 'updateMessagesInstrument',
});

export type UpdateMessagesAccount = { type: 'updateMessagesAccount'; tabId: string; accountIds: string[] | null };
export const updateMessagesAccount = (tabId: string, accountIds: string[] | null): UpdateMessagesAccount => ({
    tabId,
    accountIds,
    type: 'updateMessagesAccount',
});
export type MessagesActions = UpdateMessagesInstrumentAction | UpdateMessagesAccount;
